export default __webpack_public_path__ + "static/media/landing-logo-alt.bd5e1289.png";